import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { AgTechTwoColumnCardCollection } from '@agtech/web/components/Cards/Collections/AgTechCardCollection';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useReportDataGetSaleReportsQuery } from '@sales/data/reports/ReportDataQueries';
import React from 'react'
import ReportCard from '../components/cards/ReportCard';

const ReportsDialog = () => {
    const dialogQuery = useReportDataGetSaleReportsQuery();

    return (
        <AgTechViewDialog
            data={{
                query: dialogQuery
            }}
            structure={{
                header: (reports) => ({
                    header: 'My Reports',
                    detail: 'Below is a list of reports available for the current sale. To download a report, click the "Download" button beneath the report description'
                }),
                width: "800px",
            }}
        >
            {(reports) => {
                return (
                    <div className='stretched py-4 px-1 flex'>
                        <AgTechTwoColumnCardCollection
                            entities={reports}
                            card={report => (
                                <ReportCard key={report.reportName} {...report} />
                            )}
                        />
                    </div>
                )
            }}
        </AgTechViewDialog>
    )
}

ReportsDialog.ButtonProps = {
    text: 'Download Reports',
    icon: 'fas fa-chart-area',
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <ReportsDialog />
    })
};

ReportsDialog.Button = (props: AgTechButtonProps) => {
    let buttonProps: AgTechButtonProps = {
        ...ReportsDialog.ButtonProps,
        ...props
    }

    return <AgTechButton {...buttonProps} />
}

export default ReportsDialog